export default __webpack_public_path__ + "static/media/drop-down.ac2bb0f9.svg";